"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9918],{

/***/ 74263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ gridStyles; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93298);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8013);
/* storybook-check-ignore */ 




var gridStyles = {
    margin: [
        6,
        6,
        9,
        11,
        11
    ],
    colSpan12: "span 12 / span 12"
};
function Grid(_param) {
    var backgroundColor = _param.backgroundColor, children = _param.children, _verticalMargin = _param.verticalMargin, verticalMargin = _verticalMargin === void 0 ? false : _verticalMargin, _horizontalMargin = _param.horizontalMargin, horizontalMargin = _horizontalMargin === void 0 ? true : _horizontalMargin, maxWidth = _param.maxWidth, mr = _param.mr, ml = _param.ml, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "backgroundColor",
        "children",
        "verticalMargin",
        "horizontalMargin",
        "maxWidth",
        "mr",
        "ml"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "100%",
        justifyContent: "center"
    }, props), {
        backgroundColor: backgroundColor,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            width: "100%",
            maxWidth: maxWidth || "1440px",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
                display: "grid",
                columnGap: [
                    0,
                    5,
                    6
                ],
                my: verticalMargin ? gridStyles.margin : undefined,
                width: "100%",
                mr: mr || (horizontalMargin ? gridStyles.margin : undefined),
                ml: ml || (horizontalMargin ? gridStyles.margin : undefined),
                children: children
            })
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Grid);


/***/ }),

/***/ 29918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1216);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70917);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37337);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93298);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8013);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61442);
/* harmony import */ var _opendoor_bricks_theme_novo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40156);
/* harmony import */ var components_globals__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35480);
/* harmony import */ var _shared_performance_pictures__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29212);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74263);










var Container = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    target: "e1e27oy10"
})(function(props) {
    return "\n  @media (min-width: 375px) and (max-width: 460px) {\n    max-height: ".concat(props.isVideoAsset ? "560px" : "440px", ";\n  }\n  @media (min-width: 461px) and (max-width: 550px) {\n    max-height: ").concat(props.isVideoAsset ? "596px" : "490px", ";\n  }\n  @media (min-width: 551px) and (max-width: 615px) {\n    max-height: ").concat(props.isVideoAsset ? "596px" : "510px", ";\n  }\n  @media (min-width: 616px) and (max-width: 767px) {\n    max-height: ").concat(props.isVideoAsset ? "596px" : "520px", ";\n  }\n  @media (min-width: 768px) and (max-width: 865px) {\n    min-height: 396px;\n  }\n  @media (min-width: 865px) and (max-width: 992px) {\n    min-height: 472px;\n  }\n  @media (min-width: 992px) and (max-width: 1200px) {\n    min-height: 580px;\n  }\n  @media (min-width: 1201px) and (max-width: 1440px) {\n    min-height: 630px;\n  }\n  @media (min-width: 1440px) {\n    min-height: 680px;\n  }\n");
});
var PICTURE_SIZES = [
    {
        minWidth: _opendoor_bricks_theme_novo__WEBPACK_IMPORTED_MODULE_6__/* .breakpoints[0] */ .AV[0],
        maxWidth: _opendoor_bricks_theme_novo__WEBPACK_IMPORTED_MODULE_6__/* .breakpoints[1] */ .AV[1],
        preset: "square-256"
    },
    {
        minWidth: _opendoor_bricks_theme_novo__WEBPACK_IMPORTED_MODULE_6__/* .breakpoints[1] */ .AV[1],
        maxWidth: _opendoor_bricks_theme_novo__WEBPACK_IMPORTED_MODULE_6__/* .breakpoints[2] */ .AV[2],
        preset: "square-512"
    },
    {
        minWidth: _opendoor_bricks_theme_novo__WEBPACK_IMPORTED_MODULE_6__/* .breakpoints[2] */ .AV[2],
        maxWidth: _opendoor_bricks_theme_novo__WEBPACK_IMPORTED_MODULE_6__/* .breakpoints[3] */ .AV[3],
        preset: "square-512"
    },
    {
        minWidth: _opendoor_bricks_theme_novo__WEBPACK_IMPORTED_MODULE_6__/* .breakpoints[3] */ .AV[3],
        maxWidth: null,
        preset: "square-1024"
    }, 
];
var MobileSpacing = 8;
var LargeSpacing = 11;
var ExtraLargeSpacing = "80px";
var RenderLWCHeroCard = function(entry) {
    var fields = entry.fields;
    var isVideoAsset = (fields === null || fields === void 0 ? void 0 : fields.clipImage) && (fields === null || fields === void 0 ? void 0 : fields.videoUrl);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        analyticsName: "cosmos-landing-page-lwc-hero-card-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
        trackImpression: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(react_lazyload__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, {
            height: "100%",
            once: true,
            offset: components_globals__WEBPACK_IMPORTED_MODULE_2__/* .LAZY_LOAD_OFFSET */ .eH / 2,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(Container, {
                    gridColumn: _Grid__WEBPACK_IMPORTED_MODULE_4__/* .gridStyles.colSpan12 */ .m.colSpan12,
                    style: {
                        backgroundColor: "#F7F6F5",
                        borderRadius: "36px"
                    },
                    mb: [
                        6,
                        null,
                        7
                    ],
                    justifyContent: [
                        "space-between",
                        null,
                        "space-between"
                    ],
                    pl: [
                        0,
                        null,
                        LargeSpacing,
                        null,
                        ExtraLargeSpacing
                    ],
                    gap: [
                        0,
                        null,
                        4
                    ],
                    height: [
                        "472px",
                        "596px",
                        "396px",
                        "592px"
                    ],
                    flexDirection: [
                        "column",
                        null,
                        "row"
                    ],
                    alignItems: [
                        "center",
                        null,
                        "flex-start"
                    ],
                    overflow: "hidden",
                    isVideoAsset: !!isVideoAsset,
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            pt: [
                                MobileSpacing,
                                null,
                                LargeSpacing,
                                ExtraLargeSpacing
                            ],
                            px: [
                                MobileSpacing,
                                null,
                                "unset",
                                0
                            ],
                            pb: [
                                null,
                                null,
                                LargeSpacing,
                                ExtraLargeSpacing
                            ],
                            flexDir: "column",
                            justifyContent: "space-between",
                            width: "100%",
                            height: [
                                null,
                                null,
                                "100%"
                            ],
                            maxWidth: [
                                null,
                                null,
                                "299px",
                                "485px"
                            ],
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                                        tag: "h3",
                                        display: "block",
                                        typography: "$bodyLarge",
                                        fontWeight: "$medium",
                                        $largerThanMD: {
                                            typography: "$subheaderMedium"
                                        },
                                        color: "$contentPrimary",
                                        mb: 10,
                                        children: fields.heroCardName
                                    })
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    width: [
                                        "100%",
                                        null,
                                        "83%"
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                                            tag: "h3",
                                            display: "block",
                                            typography: "$subheaderMedium",
                                            $largerThanSM: {
                                                typography: "$headerSmall"
                                            },
                                            $largerThanMD: {
                                                typography: "$headerMedium"
                                            },
                                            color: "$contentPrimary",
                                            children: fields.title
                                        }),
                                        fields.titleAccent && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                                            tag: "h3",
                                            display: "block",
                                            typography: "$subheaderMedium",
                                            $largerThanSM: {
                                                typography: "$headerSmall"
                                            },
                                            $largerThanMD: {
                                                typography: "$headerMedium"
                                            },
                                            color: "$contentStateInactivePrimary",
                                            children: fields.titleAccent
                                        }),
                                        fields.body && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                                            tag: "h3",
                                            display: "block",
                                            typography: "$bodySmall",
                                            color: "$contentPrimary",
                                            mt: 20,
                                            children: fields.body
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            width: "100%",
                            height: "100%",
                            minHeight: "300px",
                            position: "relative",
                            children: isVideoAsset ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                height: "100%",
                                width: "100%",
                                justifyContent: [
                                    "center",
                                    null,
                                    "flex-end"
                                ],
                                alignItems: "flex-end",
                                pt: [
                                    null,
                                    null,
                                    10
                                ],
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)("@media (min-width:768px) and (max-width:790px){padding-right:32px;}@media (min-width:1201px) and (max-width:1250px){padding-right:16px;}"),
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    width: [
                                        "100%",
                                        null,
                                        "100%"
                                    ],
                                    justifyContent: [
                                        "center",
                                        null,
                                        "flex-end"
                                    ],
                                    minWidth: [
                                        null,
                                        null,
                                        "286px",
                                        "495px"
                                    ],
                                    maxHeight: [
                                        null,
                                        "420px",
                                        "unset"
                                    ],
                                    height: "100%",
                                    overflow: "hidden",
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("video", {
                                        height: "100%",
                                        width: "100%",
                                        src: fields === null || fields === void 0 ? void 0 : fields.videoUrl,
                                        autoPlay: true,
                                        muted: true,
                                        loop: true,
                                        playsInline: true,
                                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)("@media (max-width:529px){object-fit:cover;}@media (min-width:530px) and (max-width:767px){object-fit:contain;}@media (min-width:768px) and (max-width:1159px){object-fit:cover;}@media (min-width:1160px) and (max-width:1200px){object-fit:contain;}@media (min-width:1201px){object-fit:cover;}"),
                                        children: (fields === null || fields === void 0 ? void 0 : fields.cardImage) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                            height: "100%",
                                            bottom: "0",
                                            objectFit: "cover",
                                            right: "0",
                                            alt: "",
                                            src: fields === null || fields === void 0 ? void 0 : fields.cardImage,
                                            loading: "lazy"
                                        })
                                    })
                                })
                            }) : (fields === null || fields === void 0 ? void 0 : fields.cardImage) ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    left: "0",
                                    display: "block",
                                    bottom: "0",
                                    objectFit: "cover",
                                    objectPosition: "50% 0%",
                                    margin: 0,
                                    pt: [
                                        null,
                                        null,
                                        10
                                    ],
                                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)("@media (min-width:992px) and (max-width:1200px){transform:translate(7%,0px);}@media (min-width:1201px) and (max-width:1440px){transform:translate(5%,0);}@media (min-width:1440px){transform:translate(9%,0);}"),
                                    children: (0,_shared_performance_pictures__WEBPACK_IMPORTED_MODULE_3__/* .generatePresetPictureSet */ .eY)({
                                        photoUrl: fields === null || fields === void 0 ? void 0 : fields.cardImage,
                                        sizes: PICTURE_SIZES,
                                        debugImageSizes: false,
                                        radii: {},
                                        preload: true,
                                        lazy: false,
                                        objectFit: [
                                            "cover",
                                            "contain",
                                            "cover"
                                        ]
                                    })
                                })
                            }) : null
                        })
                    ]
                })
            })
        })
    });
};
var LWCHeroCard = {
    render: RenderLWCHeroCard
};
/* harmony default export */ __webpack_exports__["default"] = (LWCHeroCard);


/***/ })

}]);